module.exports = __webpack_public_path__ + "static/media/mainLogo.0973e862.png";